import render from './render'

export default {
  name: 'TwoRowString',

  props: {
    first: String,
    second: String,

    length: {
      type: Number,
      default: 50
    }
  },

  render
}
